import get from "src/lib/get";
import { contenfulAPI, contenfulPreviewAPI } from "./client";

const makeGetContent = (contentType) => (slug, isPreview) => {
  const client = isPreview ? contenfulPreviewAPI : contenfulAPI;
  return client
    .getEntries({
      content_type: contentType,
      include: 10,
      limit: 1,
      "fields.slug": slug,
    })
    .then((entry) => {
      const items = get(entry, "items", []);
      return items.length > 0
        ? { data: items[0].fields, error: null }
        : { data: null, error: "failed to load content" };
    });
};

export const getLandingPage = makeGetContent("pageLandingV2");
export const getOfferPage = makeGetContent("pageOffer");
export const getProductPage = makeGetContent("pageProduct");
